document.addEventListener('change', function(e) {
  const easifyInput = e.target.closest('.po-radioGroup-inputRadio');

  if (!easifyInput) return;

  // Get selected Easify option text
  const optionLabel = easifyInput
    .closest('.po-radioGroup-item')
    ?.querySelector('.po-optionItemLabel-label')
    ?.textContent
    ?.trim();

  if (!optionLabel) return;

  // Find matching Shopify variant
  const variantInput = document.querySelector(
    `.variant-option__button-label input[value="${optionLabel}"]`
  );

  if (variantInput && !variantInput.checked) {
    variantInput.click();
    variantInput.dispatchEvent(
      new Event('change', { bubbles: true })
    );
  }
});